import styled from 'styled-components';

export const BottomPanelContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundColor};
  height: 64px;
  box-shadow: ${({ theme }) => theme.shadows.default};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  border-radius: 6px;
`;

export const BottomBody = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: row;
`;

export const PlainText = styled.p`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.blackColor};
  font-size: 16px;
  padding: 0;
  margin: auto 10px;
`;
